<template>
  <div class="hls-video">
    <i class="el-icon-damai-close-o" @click="closeVideo()" v-if="hasClose"></i>
    <video controls class="hls-video-item" ref="hlsVideo"></video>
  </div>
</template>

<script>
import Hls from 'hls.js'
export default {
  name: 'hls-video',
  props: {
    videoUrl: {
      type: String,
    },
    hasClose: {
      type: Boolean,
      default() {
        return false
      },
    }
  },
  data() {
    return {
      hls: null
    }
  },
  created:function(){
    let _this = this
    _this.$once('hook:beforeDestroy', () => {
      _this.destroyHls()
    })
  },
  mounted() {
    this.loadVideoFn()
  },
  methods: {
    closeVideo () {
      this.$emit('closeVideo', '')
    },
    destroyHls:function () {
      if (this.hls) {
        this.$refs.hlsVideo.pause();
        this.hls.destroy();
        this.hls = null;
      }
    },
    loadVideoFn:function () {
      if (Hls.isSupported()) {
        this.hls = new Hls();
        // http://ivi.bupt.edu.cn/hls/cctv1hd.m3u8 // CCTV1直播源
        this.hls.loadSource(this.videoUrl);
        this.hls.attachMedia(this.$refs.hlsVideo);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log('加载成功');
          this.$refs.hlsVideo.play();
        });
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          // console.log(event, data);
          // 监听出错事件
          console.log('加载失败');
        });
      }
    }
  }
}
</script>

<style lang="less">
.hls-video {
  width: 100%;
  height: 100%;
  background-color: #000000;
  position: relative;
  .el-icon-damai-close-o {
    font-size: 16px;
    position: absolute;
    top: 5px;
    right: 5px;
    border-radius: 5px;
    z-index: 10;
    cursor: pointer;
  }
  .hls-video-item {
    width: 100%;
    height: 100%;
    z-index: 5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HlsVideo/HlsVideo.vue